import { useLocation } from 'js/lib/useRouter';
import user from 'js/lib/user';

export const useIsLohp = () => {
  const currentRoute = useLocation();
  const isFrontPage = currentRoute?.pathname?.startsWith('/frontpage');
  const isLOHPHome =
    !user.isAuthenticatedUser() && (currentRoute?.pathname === '/' || currentRoute?.pathname === '/in');
  return isFrontPage || isLOHPHome;
};
export default useIsLohp;
